import { useState, useEffect } from 'react'
import NestedFieldSearchService from './nestedFieldSearchService'

export const useNestedFieldSearch = (
	key: string,
	defaultValue: boolean = true
) => {
	const service = NestedFieldSearchService.getInstance()
	const [value, setValue] = useState(service.getSetting(key, defaultValue))

	useEffect(() => {
		const unsubscribe = service.subscribe(key, setValue)
		return unsubscribe
	}, [service, key])

	const updateValue = (enabled: boolean) => {
		service.setSetting(key, enabled)
	}

	return {
		value,
		updateValue,
	}
}
